import React, {useEffect, useState} from 'react';
import {Table, Button, Space, Modal, Form, Input, Select, message, Tooltip} from 'antd';
import {PlusOutlined, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined} from '@ant-design/icons';
import apiService from "../services/api";
import dayjs from "dayjs";
import CryptoJS from "crypto-js";
import {
    getRoleLabel,
    getRoleKeyFromLabel,
    getRoleOptions,
} from "../utils/roleUtil";

const {Option} = Select;

const salt = 'abc&#*'

const UserManagement = () => {
    const [users, setUsers] = useState([
        // {id: 1, username: 'admin', name: '管理员', role: 'admin', status: 'active', lastLoginTime: 1746963999},
        // {
        //     id: 2,
        //     username: 'operator',
        //     name: '操作员',
        //     role: 'operator',
        //     status: 'active',
        //     email: 'operator@example.com'
        // },
        // {id: 3, username: 'guest', name: '访客用户', role: 'guest', status: 'inactive', lastLoginTime: 1746963999},
    ]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalType, setModalType] = useState('add'); // 'add' or 'edit'
    const [currentUser, setCurrentUser] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        getUsers();
    }, []);

    // 函数用于加载、更新、修改、删除之后刷新表单数据
    const getUsers = async () => {
        let isMounted = true;

        try {
            const response = await apiService.user.getUsers();
            if (isMounted && response && response.code === 200) {
                // console.log("当前用户数据", response.data);
                const transformedUsers = response.data.map(user => ({
                    id: user.id,
                    username: user.username,
                    name: user.nickname,
                    phone: user.phone,
                    status: user.status === 1 ? 'active' : 'inactive',
                    role: user.userType,
                    email: user.email,
                    lastLoginTime: user.lastLoginTime
                }));
                setUsers(transformedUsers);
            }
        } catch (error) {
            console.error('获取用户数据失败:', error);
            // 可根据需求添加 UI 提示或重试机制
        }

        return () => {
            isMounted = false;
        };
    };

    const showAddModal = () => {
        setModalType('add');
        form.resetFields();
        setIsModalVisible(true);
    };

    const showEditModal = (user) => {
        setModalType('edit');
        setCurrentUser(user);
        form.setFieldsValue(user);
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleOk = async () => {
        try {
            const user = await form.validateFields()

            const data = {
                id: user.id,
                phone: user.phone,
                password: CryptoJS.SHA256(user.password + salt).toString(),
                username: user.username,
                nickname: user.name,
                userType: user.role,
                status: user.status === 'active' ? 1 : 0
            }

            console.log("增加获取修改用户数据", data)

            if (modalType === 'add') {
                const response = await apiService.user.addUser(data)

                if (response && response.code === 200) {
                    message.success('用户添加成功')
                    setIsModalVisible(false)
                } else {
                    message.error('用户添加失败')
                }

            } else {
                const response = await apiService.user.updateUser(data)

                if (response && response.code === 200) {
                    message.success('用户更新成功')
                    setIsModalVisible(false)
                } else {
                    message.error('用户更新失败')
                }
            }

            getUsers()
        }catch (err) {
            // 错误弹窗
            message.error(err.message || '请重新校验用户信息')
        }
    };

    const handleDelete = (id) => {
        Modal.confirm({
            title: '确认删除',
            content: '您确定要删除这个用户吗？此操作不可逆。',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                apiService.user.deleteUser(id).then(res => {
                    if (res.code === 200) {
                        // getUsers()
                        setUsers(users.filter(user => user.id !== id));
                        message.success('用户已删除');
                    } else {
                        message.error('删除失败')
                    }
                })
            }
        });
    };

    const toggleUserStatus = (id, currentStatus) => {
        console.log("当前用户状态", currentStatus)
        console.log("当前用户id", id)

        if (currentStatus === 'active') {
            apiService.user.disableUser(id).then(res => {
                if (res.code === 200) {

                } else {
                    message.error('禁用失败')
                    return
                }
            })
        } else {
            apiService.user.enableUser(id).then(res => {
                if (res.code === 200) {

                } else {
                    message.error('启用失败')
                    return
                }
            })
        }

        const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
        const updatedUsers = users.map(user =>
            user.id === id ? {...user, status: newStatus} : user
        );

        setUsers(updatedUsers);
        message.success(`用户状态已${newStatus === 'active' ? '激活' : '禁用'}`);
    };

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        // },
        {
            title: '用户名',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: '手机号',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '角色',
            dataIndex: 'role',
            key: 'role',
            render: (role) => {
                return getRoleLabel(role)
            }
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            render: (status,record) => (
                <span
                    style={{color: status === 'active' ? '#52c41a' : '#ff4d4f'}}
                    onClick={() => toggleUserStatus(record.id, record.status)}
                >
          {status === 'active' ? '启用' : '禁用'}
        </span>
            )
        },
        {
            title: '上次登录时间',
            dataIndex: 'lastLoginTime',
            key: 'lastLoginTime',
            render: (lastLoginTime) => (
                lastLoginTime ? dayjs(lastLoginTime).format('YYYY-MM-DD HH:mm:ss') : '-'
            ),
        },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Tooltip title="编辑">
                        <Button
                            type="primary"
                            shape="circle"
                            icon={<EditOutlined/>}
                            size="small"
                            onClick={() => showEditModal(record)}
                        />
                    </Tooltip>
                    <Tooltip title={record.status === 'active' ? '禁用' : '启用'}>
                        <Button
                            type={record.status === 'active' ? 'default' : 'primary'}
                            shape="circle"
                            icon={record.status === 'active' ? <LockOutlined/> : <UnlockOutlined/>}
                            size="small"
                            onClick={() => toggleUserStatus(record.id, record.status)}
                        />
                    </Tooltip>
                    <Tooltip title="删除">
                        <Button
                            danger
                            shape="circle"
                            icon={<DeleteOutlined/>}
                            size="small"
                            onClick={() => handleDelete(record.id)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div style={{padding: '24px'}}>
            <div style={{marginBottom: '16px', display: 'flex', justifyContent: 'space-between'}}>
                <h2 style={{margin: 0}}>用户管理</h2>
                <Button
                    type="primary"
                    icon={<PlusOutlined/>}
                    onClick={showAddModal}
                >
                    添加用户
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={users}
                rowKey="id"
                pagination={{pageSize: 10}}
            />

            <Modal
                title={modalType === 'add' ? '添加用户' : '编辑用户'}
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={modalType === 'add' ? '添加' : '保存'}
                cancelText="取消"
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item name="id" noStyle>
                        <Input type="hidden" />
                    </Form.Item>

                    <Form.Item
                        name="username"
                        label="用户名"
                        rules={[
                            {required: true, message: '请输入用户名'},
                            { min: 4, message: '用户名至少需要4个字符' },
                            { max: 20, message: '用户名不能超过20个字符' },
                            {
                                pattern: /^[a-zA-Z0-9]+$/,
                                message: '用户名只能包含字母和数字'
                            }
                        ]}
                    >
                        <Input placeholder="请输入用户名"/>
                    </Form.Item>

                    <Form.Item
                        name="name"
                        label="姓名"
                        rules={[
                            {required: true, message: '请输入用户名'},
                            { min: 2, message: '姓名至少需要2个字符' },
                            { max: 20, message: '姓名不能超过20个字符' },
                        ]}
                    >
                        <Input placeholder="请输入姓名"/>
                    </Form.Item>

                    {modalType === 'add' && (
                        <Form.Item
                            name="password"
                            label="密码"
                            rules={[
                                {required: true, message: '请输入密码'},
                                {
                                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                    message: '密码必须包含至少一个大写字母、一个小写字母、一个数字和一个特殊字符'
                                }
                            ]}
                        >
                            <Input.Password placeholder="请输入密码"/>
                        </Form.Item>
                    )}

                    <Form.Item
                        name="phone"
                        label="手机号"
                        rules={[
                            {required: true, message: '请输入手机号'},
                            {pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号'}
                        ]}
                    >
                        <Input placeholder="请输入手机号"/>
                    </Form.Item>

                    {/*<Form.Item*/}
                    {/*    name="email"*/}
                    {/*    label="邮箱"*/}
                    {/*    rules={[*/}
                    {/*        {required: true, message: '请输入邮箱'},*/}
                    {/*        {type: 'email', message: '请输入有效的邮箱地址'}*/}
                    {/*    ]}*/}
                    {/*>*/}
                    {/*    <Input placeholder="请输入邮箱"/>*/}
                    {/*</Form.Item>*/}

                    <Form.Item
                        name="role"
                        label="角色"
                        rules={[{required: true, message: '请选择角色'}]}
                    >
                        <Select placeholder="请选择角色">
                            <Option value={1}>普通用户</Option>
                            <Option value={2}>门店用户</Option>
                            <Option value={3}>供应商</Option>
                            {/*<Option value={4}>管理员</Option>*/}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="status"
                        label="状态"
                        rules={[{required: true, message: '请选择状态'}]}
                    >
                        <Select placeholder="请选择状态">
                            <Option value={1}>启用</Option>
                            <Option value={0}>禁用</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default UserManagement; 